var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.sitekey,"size":"invisible"},on:{"verify":_vm.onOk,"expired":_vm.onExpired,"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }